import axios from "axios";
import { axiosHeader } from "../../utils/helper";
import { baseUrl } from "../../utils/sysEnv";
import * as types from '../types'
import { toast } from "react-toastify";



export const createAdminUser = data => async (dispatch) => {
  try {
    dispatch({ type: types.SET_LOADING });
    await axios
      .post(`${baseUrl}/auth/register/admins`, data, axiosHeader(data.token))
      .then((res) => {
        dispatch({
          type: types.CREATE_ADMIN_USER,
          payload: res.data.data,
        });
        window.location = "/admins";
      })
      .catch((error) => {
        if (error.response === undefined) {
          toast.error("axios error", error.response);
          dispatch({ type: types.RESET_LOADING });
        } else {
           toast.error(error.response);
           dispatch({ type: types.RESET_LOADING });
        }
      });
  } catch (err) {
    dispatch({ type: types.SET_ERROR });
     toast.error(err.message.data.error);
  }
};

// GET ALL admin users
export const getAdminUsers = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${baseUrl}/admins`, axiosHeader(info.token))
        .then((res) => {
          dispatch({
            type: types.GET_ADMIN_USERS,
            payload: res.data.data,
          });
          dispatch({ type: types.RESET_LOADING });
        })
        .catch((error) => {
          if (error.response === undefined) {
            // toast.error(error.message);
            dispatch({ type: types.RESET_LOADING });
          } else {
            //  toast.error(error.message);
             dispatch({ type: types.RESET_LOADING });
          }
        });
    } catch (err) {
       toast.error(err.message);
       dispatch({ type: types.RESET_LOADING });
    }
  };


export const updateAdminUser = data => async (dispatch) => {

    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .put(`${baseUrl}/admins/update`, data, axiosHeader(data.token))
        .then((res) => {
          dispatch({
            type: types.EDIT_ADMIN_USER,
            payload: res.data.data,
          });
          window.location = "/admins";
        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error("axios error", error.response);
            dispatch({ type: types.RESET_LOADING });
          } else {
             toast.error(error.response);
             dispatch({ type: types.RESET_LOADING });
          }
        });
    } catch (err) {
      dispatch({ type: types.SET_ERROR });
       toast.error("axios error", err.message.data.error);
    }
  };